import {Component, Input} from '@angular/core';
import {ErrorLog} from '../models/error-log';

@Component({
  selector: 'error-log-list',
  template: `
    <div style="border:1px solid lime;max-width:600px;">
      <table>
        <tr>
          <th>Date</th>
          <th>Level</th>
          <th>Message</th>
        </tr>
        <tr *ngFor="let l of logs">
          <td>{{l.date | date: 'MM/dd/yyyy': 'UTC'}}</td>
          <td>{{l.level}}</td>
          <td>{{l.message}}</td>
        </tr>
      </table>
    </div>
    
  `
})
export class ErrorLogListComponent {

  @Input() public logs: ErrorLog[];

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/error-log-list.ts